import { useState, useEffect } from "react";
import { NAV_LINKS } from "../../data/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`sticky top-0 z-50 bg-ivory/96 backdrop-blur-xl border-b border-ink-10 transition-shadow duration-300 ${
        scrolled ? "shadow-md shadow-ink/8" : ""
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-16">
        <div className="flex items-center justify-between h-[72px]">
          {/* Logo */}
          <a href="#top" className="font-syne text-[1.45rem] font-extrabold tracking-tight leading-none">
            <span className="text-ink">Ol</span>
            <span className="text-gold">ó</span>
            <span className="text-violet-light">ye</span>
            <span className="text-ink-20 mx-0.5"> </span>
            <span className="text-ink">Ev</span>
            <span className="text-violet-light">en</span>
            <span className="text-gold">ts</span>
          </a>

          {/* Desktop Links */}
          <ul className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="font-syne text-[10px] font-semibold tracking-[0.16em] uppercase text-ink-35 hover:text-ink transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-6">
            <a
              href="/capability_statement.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="font-syne text-[10px] font-semibold tracking-[0.14em] uppercase text-ink-55 border border-ink-20 px-[18px] py-2 rounded-sm hover:border-violet hover:text-violet transition-all"
            >
              Capability Statement
            </a>
            <a
              href="#contact"
              className="font-syne text-[10px] font-bold tracking-[0.16em] uppercase text-white bg-violet px-[22px] py-[9px] rounded-sm hover:bg-violet-deep transition-colors"
            >
              Book Now
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 p-1"
            onClick={() => setMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            <span className={`block w-6 h-px bg-ink transition-transform duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`block w-6 h-px bg-ink transition-opacity duration-300 ${menuOpen ? "opacity-0" : ""}`} />
            <span className={`block w-6 h-px bg-ink transition-transform duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden bg-white border-b border-ink-10 py-4 flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="text-xs text-ink-55 uppercase tracking-widest hover:text-ink transition-colors"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="#contact"
              className="font-syne text-[10px] font-bold tracking-[0.16em] uppercase text-center text-white bg-violet px-[22px] py-[9px] rounded-sm hover:bg-violet-deep transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              Book Now
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
